module.exports = __webpack_public_path__ + "img/adult-dash-runamoc-grey-black_1.b201a64d.jpg";